{
	"title": "Импресум",
	"backTitle": "Назад",
	"company": {
		"name": "HDigital GmbH",
		"address": {
			"street": "Berliner Strasse 6",
			"city": "69120 Heidelberg",
			"country": "Германия"
		},
		"contact": {
			"telephone": "Телефон: +49 6221 481-0",
			"telefax": "Факс: +49 6221 481-13553",
			"email": "Имейл: info@heidelbergmaterials.com"
		},
		"legal": {
			"registeredOffice": "Седалище на дружеството: Heidelberg",
			"commercialRegister": "Търговски регистър: Mannheim, HRB 741878",
			"managingDirectors": "Управители:",
			"directors": {
				"rene": "René Aldach",
				"roland": "Roland Sterr",
				"noman": "Noman Ahmed"
			}
		}
	}
}
